import { ASSET_PREFIX } from 'utils/constants';
import RoundedButton, { ColorStyle } from 'components/RoundedButton';
import Chevron from 'components/Chevron'

const WhatsIncludedSection = ({ ctaHandler, onViewFullTerms }) => (
  <div className="container">
    <div className="contentSide">
      <div className="contentContainer">
        <div className="paddedMaxWidthContainer">
          <h3 style={{ marginBottom: '0.2em', textAlign: 'left' }}>
            What's <strong>Included</strong>
          </h3>

          <ul style={{ fontWeight: 600 }}>
            <li>
              Return flights & transfers for 2 to Reykjavik, Iceland.
            </li>

            <li>
              5 nights’ accommodation for 2 at The ION Adventure Hotel, Reykjavik.
            </li>

            <li>
              Private jeep transfers to the volcano.
            </li>

            <li>
              A private dining experience for 2 inside a dormant volcano with all drinks and food included with the services of a private chef throughout.
            </li>
          </ul>

          <p style={{ fontStyle: 'italic' }}>
            <span onClick={onViewFullTerms} className="viewFullTermsLink">
              See terms
              <Chevron
                direction="right"
                style={{
                  marginLeft: '0.8em',
                  verticalAlign: 'middle',
                  display: 'inline',
                  fontSize: '1.1em',
                }}
              />
            </span>
          </p>
        </div>
      </div>
    </div>

    <img
      className="image"
      src={`${ASSET_PREFIX}/images/iceland-raffle/northern-lights.jpg`}
      alt="Lifting lowering down into volcano"
    />

    <style jsx>
      {`
        .container {
          width: 100%;
          display: flex;
        }
        
        .image {
          object-fit: cover;
          object-position: 50% 75%;
          height: 100%;
          max-height: 520px;
        }
        
        .container>* {
          width: 50%;
        }
        
        .contentSide {
          display: flex;
          justify-content: flex-end;
          align-items: center;
        }
        
        .ctaContainer {
          width: 100%;
          margin: 2em 0;
          text-align: left;
        }
        
        .paddedMaxWidthContainer {
          margin: auto;
          align-items: flex-start;
          padding: 40px 2em 75px;
          max-width: 500px;
        }
        
        .viewFullTermsLink {
          cursor: pointer;
          font-weight: 800;
          margin-left: 1em;
        }
        
        @media(max-width: 800px) {
          .paddedMaxWidthContainer {
            padding-left: 0.5em;
            padding-right: 0.5em;
            padding: 40px 1em;
          }
          
          .image {
            // Fixes bug on physical iOS device where parent section was filled in image.
            height: auto;
            max-height: 300px;
          }
          
          .container {
            flex-direction: column;
          }
          
          .container>* {
            width: 100%;
          }
          
          .contentContainer {
            margin: 0 auto;
          }
          
          .ctaContainer {
            text-align: center;
          }
        }
      `}
    </style>
  </div>
);

export default WhatsIncludedSection;
